import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredMoldReceiving,
  selectMoldReleaseLoading,
  selectfetchMoldReleaseLoading,
  selectMoldReceivingFilters,
} from './store/selectors';
import { editMoldReleaseData } from './store/slice';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const MoldReleaseTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading, isFetchDataLoading, filters } = useSelector(state => ({
    filteredData: selectFilteredMoldReceiving(state),
    isLoading: selectMoldReleaseLoading(state),
    isFetchDataLoading: selectfetchMoldReleaseLoading(state),
    filters: selectMoldReceivingFilters(state),
  }));

  const handleEditClick = record => {
    // Get current status from the store
    const currentStatus = filters?.isReleased ?? 0; // Default to Released (0)
    dispatch(editMoldReleaseData({ moldReceiving: record, currentStatus }));
  };

  const columns = [
    {
      title: 'Tool ID',
      dataIndex: 'toolID',
      sorter: (a, b) => a.toolID.length - b.toolID.length,
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      sorter: (a, b) => a.customerName.length - b.customerName.length,
    },
    {
      title: 'Customer Email',
      dataIndex: 'customerEmail',
      sorter: (a, b) => a.customerEmail.length - b.customerEmail.length,
    },

    {
      title: 'Mold Number',
      dataIndex: 'moldNumber',
      sorter: (a, b) => a.moldNumber.length - b.moldNumber.length,
    },
    {
      title: 'Mold Description',
      dataIndex: 'moldDescription',
      sorter: (a, b) => a.moldDescription.length - b.moldDescription.length,
    },
    {
      title: 'Shipment Date',
      dataIndex: 'shipmentDate',
      sorter: (a, b) => a.shipmentDate.length - b.shipmentDate.length,
    },
    {
      title: 'Received Date',
      dataIndex: 'receivedDate',
      sorter: (a, b) => a.receivedDate.length - b.receivedDate.length,
    },

    {
      title: 'Actions',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            {/* <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.id)}>
                         <i data-feather="trash-2" className="feather-trash-2"></i>
                       </Link> */}
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default MoldReleaseTable;
